export enum InventoryLevelKind {
    Empty = 1,
    Low = 2,
    High = 3,
}
